import { type ReactNode, useEffect, useRef } from 'react';

/**
 * Janela no estilo do Business Tour: faixa colorida com o título, cartão creme com
 * folhas empilhadas atrás e o X branco para fechar.
 */
export function Sheet({
  title,
  onClose,
  children,
  tone,
  color,
  wide,
}: {
  title: string;
  onClose?: () => void;
  children: ReactNode;
  tone?: 'sorte' | 'reves' | 'caos' | 'danger';
  /** Cor da faixa (ex.: cor do grupo da cidade). */
  color?: string;
  wide?: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div
        className={`sheet ${tone ? `sheet-${tone}` : ''} ${wide ? 'is-wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        ref={ref}
        onClick={(e) => e.stopPropagation()}
        style={color ? ({ '--ribbon': color } as React.CSSProperties) : undefined}
      >
        <i className="sheet-paper" aria-hidden="true" />
        <div className="ribbon sheet-head">
          <h2>{title}</h2>
          {onClose && (
            <button className="ribbon-x" onClick={onClose} aria-label="Fechar">
              <svg viewBox="0 0 20 20" aria-hidden="true">
                <path d="M4 4 L16 16 M16 4 L4 16" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
              </svg>
            </button>
          )}
        </div>
        <div className="sheet-body">{children}</div>
      </div>
    </div>
  );
}
